import styled from "styled-components";
export const ListContainer = styled.section`
  padding: 32px 0;
`;
